import { render, staticRenderFns } from "./ProjectsComponent.vue?vue&type=template&id=0507b98f&scoped=true"
import script from "./ProjectsComponent.vue?vue&type=script&lang=js"
export * from "./ProjectsComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectsComponent.vue?vue&type=style&index=0&id=0507b98f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0507b98f",
  null
  
)

export default component.exports